module.exports = __webpack_public_path__ + "media/images/admin/icons/clock-38585fec598ef79bfbd0c5c4b099074a.svg";